import type { ReactNode } from 'react';

import ScrollRail from '@/components/rail/scroll-rail';

import { CARD_ROWS } from './media-card';

/**
 * `MediaCard`s in a sideways rail — `MediaCardRow`'s scrolling counterpart.
 *
 * All it adds to `ScrollRail` is the one thing that is true of these cards and
 * not of rails in general: they share six grid tracks with each other, so their
 * titles, descriptions and footers line up whichever card is longest.
 *
 * The arrows take the rail's own default and centre on the card — the whole
 * card, picture and words, which is the element they are framing. `align`
 * remains the switch if a row ever wants them on the pictures instead.
 *
 * It exists so that neither fact has to be restated at a call site. Swapping a
 * `MediaCardRow` for one of these is a one-word change; anything that is not a
 * `MediaCard` should use `ScrollRail` directly.
 */
export default function CardRail({
  children,
  label,
  className,
}: {
  children: ReactNode;
  label: string;
  className?: string;
}) {
  return (
    <ScrollRail label={label} rows={CARD_ROWS} className={className}>
      {children}
    </ScrollRail>
  );
}
